import { Component, OnInit, ViewChild } from '@angular/core';
import { CustomerService } from '../../../services/customer.service';
import { gridPageRequest } from '../../../model/common/common.model';
import { SharedModule } from '../../../shared/shared.module';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { customer } from '../../../model/masters.model';
import { SalesService } from '../../../services/sales.service';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-shiptocustomer-lookup',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './shiptocustomer-lookup.component.html',
  styleUrl: './shiptocustomer-lookup.component.scss'
})
export class ShipToCustomerLookupComponent implements OnInit {
  products: any;
  submitted: any;
  formControls: any;
  ShipTocustomerList: any[] = [];
  searchKey : any;


  constructor(private customerService: CustomerService, public ref: DynamicDialogRef,private salesService: SalesService) { }
  @ViewChild('dt1') dt1: Table | undefined;

  customers: customer[] = [];
  loader: boolean = false;

  ngOnInit(): void {
    this.getCustomers();
  }

  pageRequest: gridPageRequest = {
    id: 0,
    pageIndex: 0,
    pageSize: 10,
  };

  getCustomers() {
    this.loader = true;
    this.customerService.getCustomerForOrder(this.pageRequest, true).subscribe({
      next: data => {
        this.loader = false;
        const jsonData = typeof data === 'string' ? JSON.parse(data) : data;
        const customers = jsonData.customers;
        this.customers = customers;
      },
      error: error => {
        console.log(error);
        this.loader = false;
      }
    });
  }


  SelectOption(event: any) {
    if (event?.data) {
      this.ref.close(event?.data);
    } else {
      this.ref.close(event);
    }
  }


  searchCustomer() {
    if (!this.searchKey) {
      return;
    }
    this.loader = true;
    this.salesService.autoSearchCustomer(this.searchKey).subscribe(
      (data: any) => {
        this.loader = false;
        if (Array.isArray(data)) {
          const customers = data.filter((item: { isShipToCustomer: boolean | null }) => item.isShipToCustomer === true);
          this.customers = customers;
        } else {
          console.error('Unexpected response format:', data);
        }
        if (this.dt1) {
          this.dt1.first = 0;
        }
        this.searchKey = '';
      },
      (error: any) => {
        console.error('Error occurred while searching customers:', error);
        this.loader = false;
      }
    );
  }

  refreshData(): void {
    if (this.dt1) {
      this.dt1.first = 0;
    }
    this.getCustomers();
  }

  load(event: any){
    this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
    this.getCustomers();
  }

}
